import styled from "styled-components";
import SbButton from "uiCore/SbButton/SbButton";

// ─── Drawer geometry ─────────────────────────────────────────────────────────
// Expressed through antd's semantic `styles` API (root / wrapper / section)
// rather than a stylesheet: antd injects its
// `.ant-drawer-right > .ant-drawer-content-wrapper { top: 0; bottom: 0;
// inset-inline-end: 0 }` rule at RUNTIME via cssinjs, so an equal-specificity
// CSS rule loses the tie and would need `!important` on every property. Inline
// semantic styles win outright.

export const DRAWER_BODY_STYLES = {
  header: { padding: 0, borderBottom: "none" },
  body: { padding: 0, display: "flex", flexDirection: "column", overflow: "hidden" },
};

// Minimizing does not hide Allie — it docks the panel as a small card in the
// bottom-right corner so the conversation stays live and visible while the user
// works on the page Allie sent them to (e.g. the JD creation drawer).
// With mask={false} antd still lays the drawer root over the viewport, so the
// root ignores pointer events (page underneath stays clickable, which is the
// whole point of docking) and the card takes them back.
export const COMPACT_DRAWER_STYLES = {
  ...DRAWER_BODY_STYLES,
  root: { pointerEvents: "none" },
  wrapper: {
    pointerEvents: "auto",
    maxWidth: "calc(100vw - 32px)",
    height: "min(460px, calc(100vh - 120px))",
    top: "auto",
    bottom: 24,
    insetInlineEnd: 24,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 8px 28px rgba(0, 0, 0, 0.22)",
  },
  section: { borderRadius: 12, height: "100%" },
};

// Ask Allie floating trigger ("screen logo"): a uiCore SbButton whose brand
// colour is derived from the theme, so it tracks the single brand source and
// never falls back to the legacy SCSS teal.
export const AskAllieFabStyled = styled(SbButton)`
  && {
    border-color: ${(p) => p.theme?.colors?.primary} !important;
    color: ${(p) => p.theme?.colors?.primary} !important;

    &:hover,
    &:focus {
      border-color: ${(p) => p.theme?.colors?.primary} !important;
      color: ${(p) => p.theme?.colors?.primary} !important;
    }
  }
`;
